<script>
import MethodButtonBase from './MethodButtonBase';
import PtIdIcon from '../../assets/svg/cartao-de-cidado.svg';
export default {
  name: 'IdCardButtonPt',
  components: {
    MethodButtonBase,
    PtIdIcon,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <PtIdIcon :class="$style.icon" />
    </template>
    <template v-slot:slot2>
      {{ $t('id-card') }}
    </template>
  </MethodButtonBase>
</template>

<style lang="scss" module>
.icon {
  display: block;
  width: 27px;
  height: auto;
  margin-right: 8px;
}
</style>
